import React, { useState, useContext } from 'react';
import styles from './ZavrsniRadoviSearchForm.module.css';
import { ThemeContext } from '../contexts/ThemeContext';
import ZavrsniRadoviFilterToggleButton from './ZavrsniRadoviFilterToggleButton';
import ZavrsniRadoviFilterMenu from './ZavrsniRadoviFilterMenu';

const ZavrsniRadoviSearchForm = (props) => {
  const { dark } = useContext(ThemeContext);
  const [showFilterMenu, setShowFilterMenu] = useState(false);
  const [searchTerm, setSearchTerm] = useState();
  const [searchField, setSearchField] = useState("tema");

  const formSubmitHandler = (e) => {
    e.preventDefault();
    props.filterRadovi(searchTerm, searchField);
  }

  return (
    <form onSubmit={formSubmitHandler} className={styles.searchForm}>
      <div className={styles.searchContainer}>

        <div className={styles.searchHeaderContainer}>

          <ZavrsniRadoviFilterToggleButton toggleFilterMenu={() => setShowFilterMenu(!showFilterMenu)} />
          <div className={styles.searchInputsContainer}>
            <input
              type="text"
              spellCheck="false"
              className={dark ? styles.searchInputDark : styles.searchInputLight}
              placeholder='Unesite pojam za pretragu...'
              onChange={e => setSearchTerm(e.target.value)} />
            <select className={dark ? styles.fieldSelectDark : styles.fieldSelectLight} value={searchField} onChange={e => setSearchField(e.target.value.trim())}>
              <option value="tema">Naslov rada</option>
              <option value="obrazlozenje">Opis rada</option>
              {/*<option value="trenutniStatus.statusZavrsnogRada.naziv">Status rada</option>*/}
              <option value="predsjednikKomisije.ime">Predsjednik komisije</option>
              <option value="mentor.ime">Mentor</option>
              <option value="clanKomisije.ime">Član komisije</option>
              <option value="studentIme">Student</option>
            </select>
            <input
              type="submit"
              className={dark ? styles.submitButtonDark : styles.submitButtonLight}
              value="Pretraži"
              onClick={() => props.filterRadovi(searchTerm, searchField)} />
          </div>
        </div>
        <ZavrsniRadoviFilterMenu 
          showRadoviFilterMenu={showFilterMenu}
          selectedCiklus={props.selectedCiklus}
          selectedStatus={props.selectedStatus} 
          setSelectedCiklus={props.setSelectedCiklus}
          setSelectedStatus={props.setSelectedStatus}/>
      </div >
    </form>
  );
}

export default ZavrsniRadoviSearchForm;